import React, { useState } from "react";
import { withRouter } from "../_shared/withRouter";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LearnerAuthShell from "./learnerAuthShell";
import InputComponent from "../template/_common/inputComponent";
import LanguageSelector from "../template/_common/languageSelector";
import { globalAlert } from "../actions/commonActions";
import { SUPPORTED_LANGUAGES } from "../i18n/languages";
import { emailShapeOk, resolveLmsShortName, learnerPath } from "./_learnerConfig";
import { learnerForgotPasswordApi } from "./_learnerActions";

// Forgot password. Always shows the SAME generic confirmation regardless of
// whether the account exists (no account enumeration).
const LearnerForgotPassword = (props) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!emailShapeOk(email)) {
      setError(t("learner.lms.errors.emailInvalid", "Enter a valid email address."));
      return;
    }
    setBusy(true);
    try {
      const res = await learnerForgotPasswordApi({ email: email.trim() });
      const { status, message, data } = res?.data || {};
      if (status === 204) {
        setError(message || data?.message || "No account found for this email address.");
      } else {
        setSent(true);
        setMessage(message || data?.message || "Password reset link sent successfully.");
      }
    } catch (err) {
      // Only hard network/server errors surface.
      globalAlert("error", err?.response?.data?.message);
    }
    setBusy(false);
  };

  return (
    <LearnerAuthShell
      title={t("learner.lms.forgot.title", "Reset your password")}
      heading={t("learner.lms.forgot.title", "Reset your password")}
      headingExtra={
        // <LanguageSelector
        //   variant="dark"
        //   languages={SUPPORTED_LANGUAGES}
        //   value={localStorage.getItem("userLanguage") || "en"}
        //   label={t("common.selectLanguage", "Select Language")}
        // />
        null
      }
      organisation={props?.portalInfo?.organisation}
      subheading={
        sent
          ? undefined
          : t("learner.lms.forgot.sub", "Enter your email and we'll send you a reset link.")
      }
      footer={
        <Link to={learnerPath(resolveLmsShortName(), "login")} className="lms-auth-link text-decoration-none" style={{ color: '#ffffff', fontSize: '16px' }}>
          <i className="fas fa-arrow-left me-2"></i>
          {t("learner.lms.forgot.backToLogin", "Back to Login")}
        </Link>
      }
    >
      {sent ? (
        <div className="lms-auth-confirm text-center">
          <div className="lms-auth-confirm-icon ok">
            <i className="fas fa-envelope-open-text"></i>
          </div>
          <p className="lms-auth-sub">
            {/* {t(
              "learner.lms.forgot.sent",
              "If an account exists for that email, we've sent a link to reset your password."
            )} */}
            {message}
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="form-own lms-auth-form" noValidate>
          <div className="form-group reg-date login-page">
            <InputComponent
              placeholder={t("user.login.emailPlaceholder", "Email")}
              label={t("user.login.emailPlaceholder", "Email")}
              name="email"
              type="text"
              keyType="email"
              theme="primary"
              color="#d7eff5"
              maxLength={40}
              value={email}
              autoComplete="email"
              handleCallback={(val) => {
                setEmail(val);
                if (error) setError("");
              }}
            />
            {error && (
              <span id="forgot-err" className="error-text font-12 pl-2" role="alert">
                {error}
              </span>
            )}
          </div>
          <button
  type="submit"
  className="btn primary-btn btn-block lms-auth-submit w-100"
  disabled={busy}
  aria-label={
    busy
      ? t("learner.lms.forgot.sending", "Sending reset link")
      : t("learner.lms.forgot.button", "Send password reset link")
  }
>
  {busy ? (
    <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
  ) : (
    t("learner.lms.forgot.button", "Send password reset link")
  )}
</button>
        </form>
      )}
    </LearnerAuthShell>
  );
};

export default withRouter(LearnerForgotPassword);
